import { useQuery, useMutation } from "@tanstack/react-query";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose,
} from "@/components/ui/dialog";
import { fetchFeedBackTypes, createPropertyFeedBack } from "@/lib/api";
import { toast } from "sonner";
import { Warning, CaretRight } from "@phosphor-icons/react";

export const ReportDialog = ({ propertyId, open, onOpenChange }) => {
  const { data: reasons = [] } = useQuery({
    queryKey: ["feedback-types"],
    queryFn: fetchFeedBackTypes,
    enabled: open,
    staleTime: 1000 * 60 * 30,
  });

  const mut = useMutation({
    mutationFn: ({ fkIdProperty, fkIdFeedbackType }) => createPropertyFeedBack(fkIdProperty, fkIdFeedbackType),
    onSuccess: () => {
      toast.success("Şikayətiniz qəbul olundu");
      onOpenChange(false);
    },
    onError: (e) => toast.error(e.message || "Xəta baş verdi"),
  });

  const send = (fkIdFeedbackType) =>
    propertyId && mut.mutate({ fkIdProperty: propertyId, fkIdFeedbackType });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm p-0 gap-0 overflow-hidden">
        <div className="px-5 py-3.5 flex items-center border-b border-border/60 bg-secondary/60">
          <div className="flex items-center gap-2 font-semibold text-base">
            <Warning size={16} weight="fill" className="text-primary" />
            Bu elanı şikayət et
          </div>
        </div>
        <DialogHeader className="sr-only"><DialogTitle>Şikayət et</DialogTitle></DialogHeader>

        <div className="p-3">
          <div className="text-xs text-muted-foreground text-center mb-2">Şikayət səbəbini seçin</div>
          <div className="space-y-1.5" data-testid="report-reasons">
            {reasons.map((r) => {
              const danger = r.feedbackTypeName?.toLowerCase().includes("fırıldaq");
              return (
                <button
                  key={r.idFeedbackType}
                  type="button"
                  data-testid={`report-reason-${r.idFeedbackType}`}
                  disabled={mut.isPending}
                  onClick={() => send(r.idFeedbackType)}
                  className={`w-full flex items-center gap-3 rounded-lg border px-3 py-2.5 text-left text-sm transition-colors ${
                    danger
                      ? "border-destructive/40 hover:bg-destructive/5 text-destructive"
                      : "border-border/60 hover:border-primary/40 hover:bg-primary/[0.03]"
                  }`}
                >
                  <span
                    className="w-8 h-8 rounded-full flex items-center justify-center shrink-0 [&_svg]:w-[15px] [&_svg]:h-[15px]"
                    style={{ backgroundColor: `${r.color}1a`, color: r.color || undefined }}
                    dangerouslySetInnerHTML={{ __html: r.icon || "" }}
                  />
                  <span className="flex-1 font-medium">{r.feedbackTypeName}</span>
                  <CaretRight size={12} weight="bold" className="text-muted-foreground/60 shrink-0" />
                </button>
              );
            })}
          </div>
        </div>

        <div className="border-t border-border/60 px-3 py-2 bg-secondary/40">
          <DialogClose asChild>
            <button
              data-testid="report-cancel-btn"
              className="w-full h-10 rounded-lg text-sm font-semibold text-muted-foreground hover:text-foreground hover:bg-background/60 transition-colors"
            >
              Ləğv et
            </button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};
